<template>
  
  <div >
    <van-popup v-model="popupshow" position="bottom" v-on:click-overlay="close">
      <van-nav-bar title="评价">
        <van-icon name="close" slot="left" @click="close"/>
      </van-nav-bar>
      <sby-service-contact></sby-service-contact>
      <div class="votebox">
        <div class="vote-action-box">
          <span>评价客服</span>
          <van-rate v-model="rate"  v-bind:disabled="pay_state === 'reviewed'" disabled-color="rgb(255, 210, 30)"></van-rate>
        </div>
        <span class="feel">{{satisfied}}</span>
      </div>
      <van-field
        v-model="rate_desc"
        type="textarea"
        placeholder="留下您对我们服务的评价，非常感谢！"
        v-bind:readonly="pay_state === 'reviewed'"
        rows="3"
      />

      <div class="btnbox">
        <van-button v-if="pay_state === 'completed'"  size="small" type="primary" class="action" @click.prevent="review">提交</van-button>
        <van-button v-else-if="pay_state === 'reviewed'"  size="small" type="primary" class="action" @click.prevent="close">关闭</van-button>
        <van-button v-else size="small" type="primary" class="action" @click.prevent="close">完成</van-button>
      </div>
    </van-popup>

  </div>

</template>

<script>
import {
  Icon, Rate, Popup, Field, Button, Toast, NavBar
} from "vant";
export default {
  props: {
    serviceId: String,
    show: Boolean,
  },
  name: 'service-contact',
  components: {
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [NavBar.name]: NavBar,
    [Rate.name]: Rate
  },
  data () {
    // 支持从外面设置 状态，如果已经评价过，不应该再次评价。
    return {
      rate: 5,
      rate_desc: "",
      pay_state: "",
      popupshow: false,
      sid: "",
      fetched: false
    }
  },
  computed: {
    satisfied() {
      let rate = this.rate;
      if (rate <= 1) {
        return "非常不满意"
      } else if (rate > 1 && rate <= 2) {
        return "不满意"
      } else if (rate > 2 && rate <= 3) {
        return "一般"
      } else if (rate > 3 && rate <= 4) {
        return "满意"
      } else if (rate > 4) {
        return "非常满意"
      }
    }
  },
  watch: {
    show(val) {
      this.popupshow = val;

      if (val && this.sid && this.sid.length > 0) {
        this.fetchReview();//初始化
      }
    },
    serviceId(val) {
      this.sid = val;
    },
  },
  mounted() {

  },
  methods: {
    tel() {
      return (this.customerService && this.customerService.phone) || "4006056006";
    },
    close() {
      this.$emit('update:show', false);
    },
    fetchReview() {
      if (this.fetched) {
        return;
      }
      
      let id = this.sid;
      this.$http.get(`/api/service_order/fetchReview?orderno=${id}`)
        .then(response => {
          if (response) {
            this.onReviewFetched(response.data.data);//
            this.fetched = true;
          }
        })
        
    },
    review() {//
      this.$http.post("/api/service_order/review", {
        orderno: this.sid,
        rate: this.rate,
        desc: this.rate_desc
      }).then(response => {
          if (response) {
            this.onReviewFetched(response.data.data);//

            this.$emit('reviewed', response.data.data);

            Toast("评价客服成功");
            this.close();
          }
        })
    }
    ,
    onReviewFetched(review) {
      this.rate = review.rate;
      this.rate_desc = review.rate_desc;
      this.pay_state = review.pay_state;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  @import "../assets/less/var.less";

  .waitress-box {
    padding: 10px;
    width: 100%;
    display: flex;
    background-color: white;
    border-top: 1px solid #f2f2f2;
    border-bottom: 1px solid #f2f2f2;

    &>img {
      width: 40px;
      height: 40px;
      display: inline-block;
      vertical-align: middle;
      
    }
    .status {
      margin-left: 10px;
      vertical-align: middle;

      .name {
        display: block;
        font-size: 13px;
        color: @defaultTitleColor;
      }
    }

    .contact {
      display: inline-block;
      vertical-align: middle;
      flex: 0.9;
      text-align: right;
      padding: 10px;
      color: @defaultTitleColor;

    }

  }

  .votebox {
    padding: 10px;
    display: flex;
    background-color: white;
    border-bottom: 1px solid #f2f2f2;

    .vote-action-box {
      flex: 1;
      span {
        display: inline-block;
        vertical-align: middle;
        font-size: 14px;
      }
      .van-rate {
        display: inline-block;
        vertical-align: middle;
      }
    }
    .feel {
      color: #F20707;
      font-size: 14px;
    }
  }


  .btnbox {
    text-align: center;
    .action {
      margin: 5px auto;
      background-color: #0BA3D2;
      border-width: 0px;
      padding: 0px 80px;
      
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/sby-service-rate.vue